"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyWalletService = void 0;
const timestampHelper_1 = require("../../../../helpers/timestampHelper/timestampHelper");
const signerAndDecoderFromPrivateKey_1 = require("../../../../helpers/JWTGeneric/signerAndDecoderFromPrivateKey");
const JWTGeneric_1 = require("../../../../helpers/JWTGeneric/JWTGeneric");
const tsyringe_1 = require("tsyringe");
const web3_1 = __importDefault(require("web3"));
const required_1 = require("../../../../helpers/required/required");
const rightService_1 = require("../../../utils/services/rightService/rightService");
const metamaskService_1 = require("../metamask/metamaskService");
const localStorageAuthorizationKey = 'spkz_authorizations';
let ProxyWalletService = class ProxyWalletService {
    constructor(rightService, metamaskService) {
        this.rightService = rightService;
        this.metamaskService = metamaskService;
        this._authorizedAddresses = [];
        this._authorizations = [];
        /**
         * Get blockchainWallets authorizations from localstorage
         * If proxyWallet not authorized, it removes entry from localstorage and return empty array
         * @returns {[]}
         */
        this.retrieveJWTAuthorizationsFromLocalStorage = () => {
            if (typeof localStorage !== 'undefined') {
                const valueFromStorage = localStorage.getItem(localStorageAuthorizationKey);
                if (valueFromStorage) {
                    try {
                        const parseValue = JSON.parse(valueFromStorage);
                        const isAuthorized = rightService_1.RightService.isProxyWalletAuthorized(parseValue, this.address);
                        if (isAuthorized) {
                            return parseValue;
                        }
                    }
                    catch (e) {
                    }
                }
                localStorage.removeItem(localStorageAuthorizationKey);
            }
            return [];
        };
        /**
         * Check if authorizations from blockchainWallets are still valid (not expired, sub is proxyWallet...)
         * It should be call on every app launch
         * @returns {Promise<AuthorizationsStatus>}
         */
        this.checkBlockchainWalletAuthorizations = () => __awaiter(this, void 0, void 0, function* () {
            return this.rightService.proxyWalletAuthorisationStatus(this.authorizations, this.address);
        });
        this.createAuthLink = (url) => {
            const urlObject = new URL(url);
            urlObject.searchParams.append('spkz_authorizations', JSON.stringify(this.authorizations));
            urlObject.searchParams.append('spkz_proxyWalletPK', this.privateKey);
            return urlObject.href;
        };
    }
    get authorizedAddresses() {
        return [...this._authorizedAddresses];
    }
    get authorizations() {
        return [...this._authorizations];
    }
    set authorizations(value) {
        this._authorizations = value;
    }
    get privateKey() {
        return this._privateKey;
    }
    get address() {
        return this.web3Account.address;
    }
    set privateKey(value) {
        this._privateKey = value;
        this.web3Account = new web3_1.default().eth.accounts.privateKeyToAccount(this._privateKey);
        const { signer, decoder } = signerAndDecoderFromPrivateKey_1.signerDecoder(this._privateKey);
        this.signer = signer;
        this.decoder = decoder;
        this.jwtHelper = new JWTGeneric_1.JWTGeneric(this.signer, this.decoder);
        this.retrieveJWTAuthorizationsFromLocalStorage()
            .map(jwt => this.addBlockchainWalletAuthorization(jwt));
    }
    addFromMetamask() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.metamaskService.initMetamask();
            const payloadToSign = this.getPayloadToSignToAddABlockchainWallet(this.metamaskService.defaultAccount);
            const jwtSigner = new JWTGeneric_1.JWTGeneric(this.metamaskService.signData, () => {
            });
            const zef = jwtSigner.setPayload(payloadToSign);
            const signedJWT = yield zef.sign();
            this.addBlockchainWalletAuthorization(signedJWT);
            return this;
        });
    }
    addWalletFromPrivateKey(privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const { signer, decoder, address } = signerAndDecoderFromPrivateKey_1.signerDecoder(privateKey);
            const jwtSigner = new JWTGeneric_1.JWTGeneric(signer, decoder);
            const payloadToSign = this.getPayloadToSignToAddABlockchainWallet(address);
            const zef = yield jwtSigner.setPayload(payloadToSign);
            const signedJWT = yield zef.sign();
            this.addBlockchainWalletAuthorization(signedJWT);
            return this;
        });
    }
    addFromCustomWallet() {
    }
    addBlockchainWalletAuthorization(jwt) {
        return __awaiter(this, void 0, void 0, function* () {
            const issuer = this.jwtHelper.setToken(jwt).decode().payload.iss;
            required_1.required(this.jwtHelper.setToken(jwt).verify(issuer), 'iss of jwt should be the issuer');
            if (!this._authorizedAddresses.includes(issuer)) {
                this._authorizedAddresses.push(issuer);
                this._authorizations.push(jwt);
                if (typeof localStorage !== 'undefined') {
                    localStorage.setItem(localStorageAuthorizationKey, JSON.stringify(this.authorizations));
                }
            }
            return this;
        });
    }
    /**
     * Get payload to authorized messaging wallet to send message on behalf of another blockchain wallet
     * @param {string} publicKey
     * @returns {{sub: any; iss: string; exp: number}}
     */
    getPayloadToSignToAddABlockchainWallet(publicKey) {
        return {
            iss: publicKey.toLowerCase(),
            exp: timestampHelper_1.addDate(7, 'days'),
            sub: this.address.toLowerCase(),
            iat: Date.now()
        };
    }
};
ProxyWalletService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [rightService_1.RightService,
        metamaskService_1.MetamaskService])
], ProxyWalletService);
exports.ProxyWalletService = ProxyWalletService;
//# sourceMappingURL=proxyWalletService.js.map